import { cn } from "@/lib/cn";

export interface Logo2MProps {
  /** "completo": marco, 2M y DESARROLLOS; "marca": marco y 2M (chico: header, ícono). */
  variante?: "completo" | "marca";
  className?: string;
}

/**
 * Logo de 2M Desarrollos, la desarrolladora (Mati, 2026-11-03; Newbery 3563 es un desarrollo de 2M). Dibujado con
 * trazos (no depende de fuentes salvo "DESARROLLOS") y en `currentColor`: toma el color del texto donde se use.
 * El mismo dibujo está en `public/logo-2m.svg` y en los íconos de la app (`scripts/iconos-2m.mjs`).
 */
export function Logo2M({ variante = "completo", className }: Logo2MProps) {
  const completo = variante === "completo";
  return (
    <svg
      viewBox={completo ? "0 0 342 336" : "0 0 342 332"}
      role="img"
      aria-label="2M Desarrollos"
      className={cn("h-auto", className)}
      fill="none"
      stroke="currentColor"
      strokeWidth={completo ? 4 : 6}
    >
      <path d="M335 190V5H7v322h143" strokeLinecap="square" />
      <path d="M176 242a28 21 0 0 1 56 1c0 12-8 19-19 27l-37 29h60" strokeLinejoin="miter" />
      <path d="M257 299V224l39 75 39-75v75" strokeLinejoin="miter" />
      {completo && (
        <text x="172" y="331" fill="currentColor" stroke="none" fontSize="13.5" fontWeight="300" letterSpacing="3.4" textLength="164" lengthAdjust="spacing">
          DESARROLLOS
        </text>
      )}
    </svg>
  );
}
